import i18n from '@/libs/i18n'

export default {
  assetManager: {
    custom: true,
    multiUpload: false,
    showUrlInput: false,
  },
}
